import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["content", "triggerIcon", "placement", "alignment"];
import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Popover } from '@mch-group/uikit-components';

var Tip = function Tip(_ref) {
  var content = _ref.content,
      triggerIcon = _ref.triggerIcon,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'top' : _ref$placement,
      _ref$alignment = _ref.alignment,
      alignment = _ref$alignment === void 0 ? 'start' : _ref$alignment,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement(Popover, _extends({
    content: content,
    placement: placement,
    alignment: alignment,
    buttonSize: "xs"
  }, props)), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      backgroundColor: 'white',
      pointerEvents: 'none'
    }
  }, triggerIcon));
};

Tip.propTypes = {
  triggerIcon: PropTypes.node,
  title: PropTypes.string,
  content: PropTypes.string,
  placement: PropTypes.string,
  // 'top' | 'bottom'
  alignment: PropTypes.string,
  // 'start' | 'center' | 'end'
  arrow: PropTypes.bool,
  buttonSize: PropTypes.string // 'xs' | 's' | 'm'

};
Tip.defaultProps = {
  triggerIcon: /*#__PURE__*/React.createElement(Icon, {
    name: "help",
    color: "var(--bs-mch-gray-500)"
  })
};
export default Tip;